import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/xc/dev/digimaker-ui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Delete from './Delete';
import { ActionProps } from '../ActionsRender';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "config-actions"
    }}>{`Config actions`}</h1>
    <p>{`digimaker-ui supports 2 types of actions, link and component for configuration.`}</p>
    <h3 {...{
      "id": "link-action"
    }}>{`Link action`}</h3>
    <p>{`Below is a link example`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const articleActions = [{"link":"/main/edit/{id}", "name":"edit"}];
`}</code></pre>
    <h4 {...{
      "id": "link"
    }}>{`link`}</h4>
    <p>{`variables of link:`}</p>
    <ul>
      <li parentName="ul">{`content/inline: properties of the content(if it's from content/inline)(eg. {id}.
Note:`}
        <blockquote parentName="li">
          <p parentName="blockquote">{`Note: special variable: {_contenttype_id} is contenttype with id(eg. image/10) - for non-location content mainly).`}</p>
        </blockquote>
      </li>
      <li parentName="ul">{`list: `}
        <ul parentName="li">
          <li parentName="ul">{`{_from_id}, `}</li>
          <li parentName="ul">{`{_from_list_contenttype} from 'list'.`}</li>
        </ul>
      </li>
    </ul>
    <h4 {...{
      "id": "name"
    }}>{`name`}</h4>
    <p>{`a string which is show, or reactNode where you can have your own rendering`}</p>
    <h3 {...{
      "id": "component-action"
    }}>{`Component action`}</h3>
    <p>{`Here is an example of component action where everything is customized. See `}<a parentName="p" {...{
        "href": "./Implement"
      }}>{`Implement an action`}</a>{` for more.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const articleActions = [Copy, Delete];
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      